import { BasePageProps, BasePageState, basePageInitialState } from '../BasePage'

import { store } from '../../redux/store'

import { createReducer, createAction } from '@reduxjs/toolkit'

export interface HealthPageProps extends BasePageProps {}

type HealthState = {
    soggetti: string | undefined
    reddito: string | undefined
    coperture: string | undefined
    hasSituazioni: boolean | undefined
    situazioni: string | undefined
    hasPatologie: boolean | undefined
    patologie: string | undefined

    soggettiError: string | undefined
    redditoError: string | undefined
    copertureError: string | undefined
    situazioniError: string | undefined
    patologieError: string | undefined

    hasSituazioniError: string | undefined
    hasPatologieError: string | undefined

    tipo_tutelati: any
    tipo_tutelesalute: any
    tipo_reddito: any
    tipo_situazioni: any
    tipo_malattie: any
}

export type HealthPageState =  HealthState & BasePageState

export const healtPageInitialState : HealthPageState = {
    ...basePageInitialState,
    ...{
        soggetti: undefined,
        reddito: undefined,
        coperture: undefined,
        situazioni: undefined,
        patologie: undefined,
        hasSituazioni: undefined,
        hasPatologie: undefined,

        soggettiError: undefined,
        redditoError: undefined,
        copertureError: undefined,
        situazioniError: undefined,
        patologieError: undefined,
        hasSituazioniError: undefined,
        hasPatologieError: undefined,

        tipo_tutelati: undefined,
        tipo_tutelesalute: undefined,
        tipo_reddito: undefined,
        tipo_situazioni: undefined,
        tipo_malattie: undefined,
    }
}

export const healthUpdate = createAction<HealthPageState>('healt/update')

export const healthReducer = createReducer ( 
    healtPageInitialState,
    (builder) => {
        builder.addCase(healthUpdate, (state, action) => {
            return action.payload as HealthPageState
        })
    }
)

export type HealtRootState = ReturnType<typeof store.getState>
export type HealtDispatch = typeof store.dispatch